import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "auth-email-confirm" }
const _hoisted_2 = {
  key: 1,
  class: "grey regular align-center"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 1,
  class: "auth-email-confirm__verification"
}
const _hoisted_5 = { class: "medium" }
const _hoisted_6 = { class: "code-wrapper" }
const _hoisted_7 = { class: "timer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, watch, onBeforeUnmount, useSlots } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { NetworkHelper, UserService } from 'api';
  import { isIOSChrome, intercom } from '@/plugins';
  import { Events } from '@/analytics';
  import { UI, User } from 'types';
  import ButtonComponent from '@/views/components/ButtonComponent.vue';
  import PincodeInputComponent from '@/views/components/PincodeInputComponent';
  import CountdownComponent from '@/views/components/CountdownComponent.vue';
  import SpinnerComponent from '@/views/components/SpinnerComponent.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EmailConfirmComponent',
  props: {
    bin: {
      type: String,
    },
    email: {
      type: String,
    },
    isSubmitEnable: {
      type: Boolean,
      default: false,
    },
    getRequestParams: {
      type: Function,
    },
    onError: {
      type: Function,
    },
    applyFormEvent: {
      type: Function,
    },
    toggleLoading: {
      type: Function,
    },
    onFullCardRequired: {
      type: Function,
    },
  },
  emits: ['onChangeEmail'],
  setup(__props, { expose, emit }) {

const props = __props

  const { t } = useI18n();
  const store = useStore();
  const slots = useSlots();

  
  

  const isCriOS = isIOSChrome();

  const counting = ref<boolean>(true);
  const isLoading = ref<boolean>(false);
  const isCodeRequested = ref<boolean>(false);
  const code = ref<UI.FormField>(new UI.FormField());
  const checkCodeStart = ref<number>(0);
  const codeRef = ref<InstanceType<typeof PincodeInputComponent>>(null);

  function changeEmal() {
    code.value.reset();
    isCodeRequested.value = false;
    emit('onChangeEmail');
  }

  async function requestCode() {
    const body: User.ML.Request.Login | User.ML.Request.Register =
      await props.getRequestParams();

    if (!body || isLoading.value) {
      return;
    }

    isLoading.value = true;

    if (props.applyFormEvent) {
      props.applyFormEvent();
    }

    const isSpecialBin = (response: any): boolean => {
      return (
        response.hasOwnProperty('fullPanRequired') && response.fullPanRequired
      );
    };

    const useCase = body.isLogin
      ? UserService.ML.login(body)
      : UserService.ML.register(body);

    useCase
      .subscribe(
        res => {
          if (body.email) {
            intercom.update({ email: body.email });
          }

          if (isSpecialBin(res.data)) {
            props.onFullCardRequired(res.data);
            return;
          }

          code.value.reset();

          if (codeRef.value?.clearInput) {
            codeRef.value.clearInput();
          }

          isCodeRequested.value = true;
          checkCodeStart.value = Date.now();
          Events.Auth.checkCodeStart(body.email);
        },
        err => {
          props.onError(err.message);
        },
      )
      .add(() => {
        isLoading.value = false;
      });
  }

  function submitCode() {
    const body: User.ML.Request.Register | User.ML.Request.Login =
      props.getRequestParams();

    if (!body || isLoading.value) {
      return;
    }

    isLoading.value = true;
    body.password = code.value.value;

    const useCase = body.isLogin
      ? UserService.ML.login(body)
      : UserService.ML.register(body);

    useCase
      .subscribe(
        res => {
          code.value.reset();

          if (!res.data.sessionId) {
            throw new Error(res.data.message ?? 'Session ID not found');
          }

          NetworkHelper.saveAuthCredentials(res.data);

          store.commit('user/setAuthDialogShown', false);
          store.commit('user/setRegisterDialogShown', false);
          store.dispatch('user/getUser');

          Events.Auth.checkCodeFinish(
            checkCodeStart.value,
            body.email,
            'success',
          );
        },
        err => {
          if (err.message) code.value.error = err.message;
          Events.Auth.checkCodeFinish(
            checkCodeStart.value,
            body.email,
            'error',
          );
        },
      )
      .add(() => {
        isLoading.value = false;
      });
  }

  watch(code.value, _code => {
    if (_code.value.length === 0) {
      code.value.resetError();
    }
  });

  onBeforeUnmount(() => {
    counting.value = true;
  });

  expose({
    requestCode,
  });

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isCodeRequested.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "email-form",
          style: _normalizeStyle(_unref(isCriOS) ? 'padding-bottom: 350px;' : '')
        }, [
          _renderSlot(_ctx.$slots, "default"),
          (_unref(slots).formfields)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                novalidate: "",
                onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (requestCode()), ["prevent"]))
              }, [
                _renderSlot(_ctx.$slots, "formfields", { isLoading: isLoading.value }),
                _createVNode(ButtonComponent, {
                  enable: __props.isSubmitEnable,
                  variant: "secondary",
                  class: "no-shadow no-text-transform"
                }, {
                  default: _withCtx(() => [
                    (isLoading.value)
                      ? (_openBlock(), _createBlock(SpinnerComponent, {
                          key: 0,
                          color: "black"
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(t)('continueBtn')), 1)
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["enable"])
              ], 32))
            : _createCommentVNode("", true),
          (_unref(slots).policy)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                _renderSlot(_ctx.$slots, "policy")
              ]))
            : _createCommentVNode("", true),
          (_unref(slots).footer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "footer")
              ]))
            : _createCommentVNode("", true)
        ], 4))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_i18n_t, {
            keypath: "authModal.confirmVerificationCodeText",
            tag: "p",
            class: "regular black align-center",
            scope: "global"
          }, {
            email: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(__props.email), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(PincodeInputComponent), {
              ref_key: "codeRef",
              ref: codeRef,
              "num-inputs": 5,
              "should-auto-focus": true,
              "input-type": "number",
              value: code.value.value,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((code.value.value) = $event)),
              errorText: code.value.error,
              onOnComplete: submitCode
            }, null, 8, ["value", "errorText"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (counting.value)
              ? (_openBlock(), _createBlock(CountdownComponent, {
                  key: 0,
                  time: 60000,
                  onCountdownend: _cache[2] || (_cache[2] = ($event: any) => (counting.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_i18n_t, {
                      keypath: "authModal.receiveCodeTimerText",
                      tag: "p",
                      class: "regular grey align-center",
                      scope: "global"
                    }, {
                      break: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(ButtonComponent, {
                  key: 1,
                  class: "no-text-transform",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (requestCode()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('authModal.resendCodeBtn')), 1)
                  ]),
                  _: 1
                }))
          ]),
          _createVNode(ButtonComponent, {
            enable: code.value.value.length === 5,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (submitCode())),
            variant: "secondary",
            class: "no-shadow no-text-transform"
          }, {
            default: _withCtx(() => [
              (isLoading.value)
                ? (_openBlock(), _createBlock(SpinnerComponent, {
                    key: 0,
                    color: "black"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)('continueBtn')), 1)
                  ], 64))
            ]),
            _: 1
          }, 8, ["enable"]),
          _createVNode(ButtonComponent, {
            class: "non-padding auth-email-confirm__verification_back no-text-transform",
            style: _normalizeStyle(_unref(isCriOS) ? 'position: relative' : ''),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (changeEmal()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('back')), 1)
            ]),
            _: 1
          }, 8, ["style"])
        ]))
  ]))
}
}

})